import './Regulation.scss';
import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useProtectedInterval } from '../../hooks/useProtectedInterval';
import EmptyState from '../../components/Layout/EmptyState';

export default function Regulation() {
    const { t } = useTranslation('regulation');
    const theme = useSelector((state) => state.APP_THEME);
    const api_url = useSelector((state) => state.API_URL);
    const navigate = useNavigate();

    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchRegulation = useCallback(async () => {
        const jwtToken = localStorage.getItem('accessToken');
        try {
            const response = await fetch(api_url + 'regulation/', {
                headers: {
                    'Authorization': `JWT ${jwtToken}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.clear();
                    navigate('/auth');
                }
                return;
            }
            const data = await response.json();
            setContent(data.content || '');
        } finally {
            setLoading(false);
        }
    }, [api_url, navigate]);

    useProtectedInterval(fetchRegulation, []);

    if (loading) {
        return (
            <div className={`regulation-page ${theme}`}>
                <div className="regulation-page__loading">{t('loading')}</div>
            </div>
        );
    }

    if (!content) {
        return (
            <div className={`regulation-page ${theme}`}>
                <EmptyState message={t('empty')} />
            </div>
        );
    }

    return (
        <div className={`regulation-page ${theme}`}>
            <div className="regulation-page__content"
                 dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    );
}
